module.exports = __webpack_public_path__ + "img/Logo-11.0c0a5866.svg";